import { GoogleAnalytics } from "@next/third-parties/google";

export default function Page() {
  return <GoogleAnalytics gaId="G-L76923R14P" />;
}
